
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dMIJ2", function(module, exports) {
// we can't safely type codemirror@v5 because of the addon system
// eslint-disable-next-line @typescript-eslint/no-explicit-any

var $apPkU = parcelRequire("apPkU");

var $7ak74 = parcelRequire("7ak74");

var $jInfY = parcelRequire("jInfY");
let loaded = false;
let parserWorker = null;
let parseTimeout = null;
let parseId = 0;

function spawnWorker() {
    if (parserWorker) parserWorker.terminate();
    parserWorker = new Worker((parcelRequire("jouGq")));
    parserWorker.onmessage = (e)=>{
        const { id, type, result, error } = e.data;
        if (id !== parseId) return;
        if (parseTimeout !== null) {
            clearTimeout(parseTimeout);
            parseTimeout = null;
        }
        if (type === "success") outputDom.value = result;
        else outputDom.value = error;
    };
}
spawnWorker();
const editorDom = document.querySelector(".editor");
const gridDom = document.querySelector(".editor-grid");
const inputDom = document.querySelector(".editor-input");
const inputTextDom = document.querySelector(".editor-input-text");
const outputDom = document.querySelector(".editor-output");
const modeBtn = document.querySelector("#modeBtn");
const formatBtn = document.querySelector("#formatBtn");
const editorInputSelect = document.querySelector(".editor-input-select");
const windowHeight = window.innerHeight;
CodeMirror.defineSimpleMode("pest", {
    start: [
        {
            regex: /\/\/.*/,
            token: "comment"
        },
        {
            regex: /[a-zA-Z_]\w*/,
            token: "constiable"
        },
        {
            regex: /=/,
            token: "operator",
            next: "mod"
        }
    ],
    mod: [
        {
            regex: /\{/,
            token: "bracket",
            next: "inside_rule"
        },
        {
            regex: /[_@!$]/,
            token: "operator-2"
        }
    ],
    inside_rule: [
        {
            regex: /\/\/.*/,
            token: "comment"
        },
        {
            regex: /"/,
            token: "string",
            next: "string"
        },
        {
            regex: /'(?:[^'\\]|\\(?:[nrt0'"]|x[\da-fA-F]{2}|u\{[\da-fA-F]{6}\}))'/,
            token: "string"
        },
        {
            regex: /\}/,
            token: "bracket",
            next: "start"
        },
        {
            regex: /#\w+/,
            token: "tag"
        },
        {
            regex: /[a-zA-Z_]\w*/,
            token: "constiable-2"
        },
        {
            regex: /=/,
            token: "operator-2"
        },
        {
            regex: /\d+/,
            token: "number"
        },
        {
            regex: /[~|*+?&!]|(\.\.)/,
            token: "operator"
        }
    ],
    string: [
        {
            regex: /"/,
            token: "string",
            next: "inside_rule"
        },
        {
            regex: /(?:[^\\"]|\\(?:.|$))*/,
            token: "string"
        }
    ],
    meta: {
        dontIndentStates: [
            "comment"
        ],
        lineComment: "//"
    }
});
CodeMirror.registerHelper("lint", "pest", function(text) {
    if (loaded) {
        const doc = CodeMirror.Doc(text);
        const errors = (0, $7ak74.lint)(text);
        const mapped = [];
        for(let i = 0; i < errors.length; i++){
            let from = doc.clipPos(eval("CodeMirror.Pos" + errors[i].get("from")));
            let to = doc.clipPos(eval("CodeMirror.Pos" + errors[i].get("to")));
            if (from.line === to.line && from.ch === to.ch) {
                to.ch += 1;
                to = doc.clipPos(to);
            }
            if (from.line === to.line && from.ch === to.ch) {
                from.ch -= 1;
                from = doc.clipPos(from);
            }
            mapped.push({
                message: errors[i].get("message"),
                from: from,
                to: to
            });
        }
        return mapped;
    } else return [];
});
const grammar = document.querySelector(".editor-grammar");
const myCodeMirror = CodeMirror.fromTextArea(grammar, {
    mode: "pest",
    lint: "pest",
    theme: "pest",
    placeholder: "Grammar"
});
(0, $jInfY.initShareButton)({
    myCodeMirror: myCodeMirror
});
function doFormat() {
    if (!loaded || !myCodeMirror) return;
    const grammar = myCodeMirror.getValue();
    const formatted = (0, $7ak74.format)(grammar);
    myCodeMirror.setValue(formatted);
}
let split = null;
let sizes = JSON.parse(localStorage.getItem("split-sizes") ?? "[33, 33, 33]");
if (!Array.isArray(sizes) || sizes.length !== 3) {
    console.warn("Invalid split sizes", sizes);
    sizes = [
        33,
        33,
        33
    ];
}
function makeResizable(wideMode) {
    if (wideMode) split = (0, $apPkU.default)([
        ".CodeMirror",
        ".editor-input",
        ".output-wrapper"
    ], {
        sizes: sizes,
        onDragEnd: function(_sizes) {
            sizes = _sizes;
            localStorage.setItem("split-sizes", JSON.stringify(sizes));
        }
    });
    else if (split) split.destroy();
}
function saveCode() {
    const grammar = myCodeMirror.getValue();
    const input = inputTextDom.value;
    const json = JSON.stringify({
        grammar: grammar,
        input: input
    });
    localStorage.setItem("last-editor-state", json);
}
function getSavedCode() {
    const json = localStorage.getItem("last-editor-state");
    const parsed = JSON.parse(json || "null");
    return parsed || {
        grammar: "",
        input: ""
    };
}
function saveRule() {
    const selectedRule = editorInputSelect?.value || "";
    localStorage.setItem("last-selected-rule", selectedRule);
}
function wideMode() {
    modeBtn.onclick = restore;
    modeBtn.innerText = "Normal Mode";
    inputDom.classList.add("wide-input");
    editorDom.classList.add("wide-editor");
    gridDom.classList.add("flex-editor");
    const upperHeight = document.querySelector("#modeBtn").scrollHeight + 30;
    gridDom.setAttribute("style", `height: ${windowHeight - upperHeight}px`);
    myCodeMirror.setSize(null, outputDom.clientHeight - 20);
    makeResizable(true);
    window.scrollTo(0, document.body.scrollHeight);
}
function restore() {
    modeBtn.onclick = wideMode;
    modeBtn.innerText = "Wide Mode";
    inputDom.classList.remove("wide-input");
    editorDom.classList.remove("wide-editor");
    gridDom.classList.remove("flex-editor");
    outputDom.setAttribute("rows", "7");
    myCodeMirror.setSize(null, outputDom.clientHeight);
    makeResizable(false);
}
modeBtn.onclick = wideMode;
formatBtn.onclick = doFormat;
(0, $7ak74.default)().then(()=>{
    loaded = true;
    const url = new URL(window.location.href);
    const hasUrlGrammar = url.searchParams.get("g");
    if (!hasUrlGrammar) {
        const { grammar, input } = getSavedCode();
        myCodeMirror.setValue(grammar);
        inputTextDom.value = input;
    }
});
inputTextDom.addEventListener("input", saveCode);
myCodeMirror.on("change", saveCode);
editorInputSelect?.addEventListener("change", saveRule);
window.addEventListener("trigger_worker", ()=>{
    if (!loaded || !parserWorker) return;
    const rule = editorInputSelect?.value;
    if (!rule || rule === "...") return;
    parseId++;
    const currentId = parseId;
    if (parseTimeout !== null) window.clearTimeout(parseTimeout);
    parseTimeout = window.setTimeout(()=>{
        if (parseId === currentId) {
            outputDom.value = "Parser timeout";
            spawnWorker();
        }
    }, 1000);
    const grammar = myCodeMirror.getValue();
    const input = inputTextDom.value;
    parserWorker.postMessage({
        id: parseId,
        grammar: grammar,
        rule: rule,
        input: input
    });
});

});
parcelRegister("apPkU", function(module, exports) {

$parcel$export(module.exports, "default", () => $79540f7d89e4ab44$export$2e2bcd8739ae039);
// The programming goals of Split.js are to deliver readable, understandable and
// maintainable code, while at the same time manually optimizing for tiny minified file size,
// browser compatibility without additional requirements
// and very few assumptions about the user's page layout.
var $79540f7d89e4ab44$var$global = typeof window !== 'undefined' ? window : null;
var $79540f7d89e4ab44$var$ssr = $79540f7d89e4ab44$var$global === null;
var $79540f7d89e4ab44$var$document = !$79540f7d89e4ab44$var$ssr ? $79540f7d89e4ab44$var$global.document : undefined;
// Save a couple long function names that are used frequently.
// This optimization saves around 400 bytes.
var $79540f7d89e4ab44$var$addEventListener = 'addEventListener';
var $79540f7d89e4ab44$var$removeEventListener = 'removeEventListener';
var $79540f7d89e4ab44$var$getBoundingClientRect = 'getBoundingClientRect';
var $79540f7d89e4ab44$var$gutterStartDragging = '_a';
var $79540f7d89e4ab44$var$aGutterSize = '_b';
var $79540f7d89e4ab44$var$bGutterSize = '_c';
var $79540f7d89e4ab44$var$HORIZONTAL = 'horizontal';
var $79540f7d89e4ab44$var$NOOP = function() {
    return false;
};
// Helper function determines which prefixes of CSS calc we need.
// We only need to do this once on startup, when this anonymous function is called.
//
// Tests -webkit, -moz and -o prefixes. Modified from StackOverflow:
// http://stackoverflow.com/questions/16625140/js-feature-detection-to-detect-the-usage-of-webkit-calc-over-calc/16625167#16625167
var $79540f7d89e4ab44$var$calc = $79540f7d89e4ab44$var$ssr ? 'calc' : [
    '',
    '-webkit-',
    '-moz-',
    '-o-'
].filter(function(prefix) {
    var el = $79540f7d89e4ab44$var$document.createElement('div');
    el.style.cssText = "width:" + prefix + "calc(9px)";
    return !!el.style.length;
}).shift() + "calc";
// Helper function checks if its argument is a string-like type
var $79540f7d89e4ab44$var$isString = function(v) {
    return typeof v === 'string' || v instanceof String;
};
// Helper function allows elements and string selectors to be used
// interchangeably. In either case an element is returned. This allows us to
// do `Split([elem1, elem2])` as well as `Split(['#id1', '#id2'])`.
var $79540f7d89e4ab44$var$elementOrSelector = function(el) {
    if ($79540f7d89e4ab44$var$isString(el)) {
        var ele = $79540f7d89e4ab44$var$document.querySelector(el);
        if (!ele) throw new Error("Selector " + el + " did not match a DOM element");
        return ele;
    }
    return el;
};
// Helper function gets a property from the properties object, with a default fallback
var $79540f7d89e4ab44$var$getOption = function(options, propName, def) {
    var value = options[propName];
    if (value !== undefined) return value;
    return def;
};
var $79540f7d89e4ab44$var$getGutterSize = function(gutterSize, isFirst, isLast, gutterAlign) {
    if (isFirst) {
        if (gutterAlign === 'end') return 0;
        if (gutterAlign === 'center') return gutterSize / 2;
    } else if (isLast) {
        if (gutterAlign === 'start') return 0;
        if (gutterAlign === 'center') return gutterSize / 2;
    }
    return gutterSize;
};
// Default options
var $79540f7d89e4ab44$var$defaultGutterFn = function(i, gutterDirection) {
    var gut = $79540f7d89e4ab44$var$document.createElement('div');
    gut.className = "gutter gutter-" + gutterDirection;
    return gut;
};
var $79540f7d89e4ab44$var$defaultElementStyleFn = function(dim, size, gutSize) {
    var style = {};
    if (!$79540f7d89e4ab44$var$isString(size)) style[dim] = $79540f7d89e4ab44$var$calc + "(" + size + "% - " + gutSize + "px)";
    else style[dim] = size;
    return style;
};
var $79540f7d89e4ab44$var$defaultGutterStyleFn = function(dim, gutSize) {
    var obj;
    return obj = {}, obj[dim] = gutSize + "px", obj;
};
// The main function to initialize a split. Split.js thinks about each pair
// of elements as an independant pair. Dragging the gutter between two elements
// only changes the dimensions of elements in that pair. This is key to understanding
// how the following functions operate, since each function is bound to a pair.
//
// A pair object is shaped like this:
//
// {
//     a: DOM element,
//     b: DOM element,
//     aMin: Number,
//     bMin: Number,
//     dragging: Boolean,
//     parent: DOM element,
//     direction: 'horizontal' | 'vertical'
// }
//
// The basic sequence:
//
// 1. Set defaults to something sane. `options` doesn't have to be passed at all.
// 2. Initialize a bunch of strings based on the direction we're splitting.
//    A lot of the behavior in the rest of the library is paramatized down to
//    rely on CSS strings and classes.
// 3. Define the dragging helper functions, and a few helpers to go with them.
// 4. Loop through the elements while pairing them off. Every pair gets an
//    `pair` object and a gutter.
// 5. Actually size the pair elements, insert gutters and attach event listeners.
var $79540f7d89e4ab44$var$Split = function(idsOption, options) {
    if (options === void 0) options = {};
    if ($79540f7d89e4ab44$var$ssr) return {};
    var ids = idsOption;
    var dimension;
    var clientAxis;
    var position;
    var positionEnd;
    var clientSize;
    var elements;
    // Allow HTMLCollection to be used as an argument when supported
    if (Array.from) ids = Array.from(ids);
    // All DOM elements in the split should have a common parent. We can grab
    // the first elements parent and hope users read the docs because the
    // behavior will be whacky otherwise.
    var firstElement = $79540f7d89e4ab44$var$elementOrSelector(ids[0]);
    var parent = firstElement.parentNode;
    var parentStyle = getComputedStyle ? getComputedStyle(parent) : null;
    var parentFlexDirection = parentStyle ? parentStyle.flexDirection : null;
    // Set default options.sizes to equal percentages of the parent element.
    var sizes = $79540f7d89e4ab44$var$getOption(options, 'sizes') || ids.map(function() {
        return 100 / ids.length;
    });
    // Standardize minSize and maxSize to an array if it isn't already.
    // This allows minSize and maxSize to be passed as a number.
    var minSize = $79540f7d89e4ab44$var$getOption(options, 'minSize', 100);
    var minSizes = Array.isArray(minSize) ? minSize : ids.map(function() {
        return minSize;
    });
    var maxSize = $79540f7d89e4ab44$var$getOption(options, 'maxSize', Infinity);
    var maxSizes = Array.isArray(maxSize) ? maxSize : ids.map(function() {
        return maxSize;
    });
    // Get other options
    var expandToMin = $79540f7d89e4ab44$var$getOption(options, 'expandToMin', false);
    var gutterSize = $79540f7d89e4ab44$var$getOption(options, 'gutterSize', 10);
    var gutterAlign = $79540f7d89e4ab44$var$getOption(options, 'gutterAlign', 'center');
    var snapOffset = $79540f7d89e4ab44$var$getOption(options, 'snapOffset', 30);
    var snapOffsets = Array.isArray(snapOffset) ? snapOffset : ids.map(function() {
        return snapOffset;
    });
    var dragInterval = $79540f7d89e4ab44$var$getOption(options, 'dragInterval', 1);
    var direction = $79540f7d89e4ab44$var$getOption(options, 'direction', $79540f7d89e4ab44$var$HORIZONTAL);
    var cursor = $79540f7d89e4ab44$var$getOption(options, 'cursor', direction === $79540f7d89e4ab44$var$HORIZONTAL ? 'col-resize' : 'row-resize');
    var gutter = $79540f7d89e4ab44$var$getOption(options, 'gutter', $79540f7d89e4ab44$var$defaultGutterFn);
    var elementStyle = $79540f7d89e4ab44$var$getOption(options, 'elementStyle', $79540f7d89e4ab44$var$defaultElementStyleFn);
    var gutterStyle = $79540f7d89e4ab44$var$getOption(options, 'gutterStyle', $79540f7d89e4ab44$var$defaultGutterStyleFn);
    // 2. Initialize a bunch of strings based on the direction we're splitting.
    // A lot of the behavior in the rest of the library is paramatized down to
    // rely on CSS strings and classes.
    if (direction === $79540f7d89e4ab44$var$HORIZONTAL) {
        dimension = 'width';
        clientAxis = 'clientX';
        position = 'left';
        positionEnd = 'right';
        clientSize = 'clientWidth';
    } else if (direction === 'vertical') {
        dimension = 'height';
        clientAxis = 'clientY';
        position = 'top';
        positionEnd = 'bottom';
        clientSize = 'clientHeight';
    }
    // 3. Define the dragging helper functions, and a few helpers to go with them.
    // Each helper is bound to a pair object that contains its metadata. This
    // also makes it easy to store references to listeners that that will be
    // added and removed.
    //
    // Even though there are no other functions contained in them, aliasing
    // this to self saves 50 bytes or so since it's used so frequently.
    //
    // The pair object saves metadata like dragging state, position and
    // event listener references.
    function setElementSize(el, size, gutSize, i) {
        // Split.js allows setting sizes via numbers (ideally), or if you must,
        // by string, like '300px'. This is less than ideal, because it breaks
        // the fluid layout that `calc(% - px)` provides. You're on your own if you do that,
        // make sure you calculate the gutter size by hand.
        var style = elementStyle(dimension, size, gutSize, i);
        Object.keys(style).forEach(function(prop) {
            // eslint-disable-next-line no-param-reassign
            el.style[prop] = style[prop];
        });
    }
    function setGutterSize(gutterElement, gutSize, i) {
        var style = gutterStyle(dimension, gutSize, i);
        Object.keys(style).forEach(function(prop) {
            // eslint-disable-next-line no-param-reassign
            gutterElement.style[prop] = style[prop];
        });
    }
    function getSizes() {
        return elements.map(function(element) {
            return element.size;
        });
    }
    // Supports touch events, but not multitouch, so only the first
    // finger `touches[0]` is counted.
    function getMousePosition(e) {
        if ('touches' in e) return e.touches[0][clientAxis];
        return e[clientAxis];
    }
    // Actually adjust the size of elements `a` and `b` to `offset` while dragging.
    // calc is used to allow calc(percentage + gutterpx) on the whole split instance,
    // which allows the viewport to be resized without additional logic.
    // Element a's size is the same as offset. b's size is total size - a size.
    // Both sizes are calculated from the initial parent percentage,
    // then the gutter size is subtracted.
    function adjust(offset) {
        var a = elements[this.a];
        var b = elements[this.b];
        var percentage = a.size + b.size;
        a.size = offset / this.size * percentage;
        b.size = percentage - offset / this.size * percentage;
        setElementSize(a.element, a.size, this[$79540f7d89e4ab44$var$aGutterSize], a.i);
        setElementSize(b.element, b.size, this[$79540f7d89e4ab44$var$bGutterSize], b.i);
    }
    // drag, where all the magic happens. The logic is really quite simple:
    //
    // 1. Ignore if the pair is not dragging.
    // 2. Get the offset of the event.
    // 3. Snap offset to min if within snappable range (within min + snapOffset).
    // 4. Actually adjust each element in the pair to offset.
    //
    // ---------------------------------------------------------------------
    // |    | <- a.minSize               ||              b.minSize -> |    |
    // |    |  | <- this.snapOffset      ||     this.snapOffset -> |  |    |
    // |    |  |                         ||                        |  |    |
    // |    |  |                         ||                        |  |    |
    // ---------------------------------------------------------------------
    // | <- this.start                                        this.size -> |
    function drag(e) {
        var offset;
        var a = elements[this.a];
        var b = elements[this.b];
        if (!this.dragging) return;
        // Get the offset of the event from the first side of the
        // pair `this.start`. Then offset by the initial position of the
        // mouse compared to the gutter size.
        offset = getMousePosition(e) - this.start + (this[$79540f7d89e4ab44$var$aGutterSize] - this.dragOffset);
        if (dragInterval > 1) offset = Math.round(offset / dragInterval) * dragInterval;
        // If within snapOffset of min or max, set offset to min or max.
        // snapOffset buffers a.minSize and b.minSize, so logic is opposite for both.
        // Include the appropriate gutter sizes to prevent overflows.
        if (offset <= a.minSize + a.snapOffset + this[$79540f7d89e4ab44$var$aGutterSize]) offset = a.minSize + this[$79540f7d89e4ab44$var$aGutterSize];
        else if (offset >= this.size - (b.minSize + b.snapOffset + this[$79540f7d89e4ab44$var$bGutterSize])) offset = this.size - (b.minSize + this[$79540f7d89e4ab44$var$bGutterSize]);
        if (offset >= a.maxSize - a.snapOffset + this[$79540f7d89e4ab44$var$aGutterSize]) offset = a.maxSize + this[$79540f7d89e4ab44$var$aGutterSize];
        else if (offset <= this.size - (b.maxSize - b.snapOffset + this[$79540f7d89e4ab44$var$bGutterSize])) offset = this.size - (b.maxSize + this[$79540f7d89e4ab44$var$bGutterSize]);
        // Actually adjust the size.
        adjust.call(this, offset);
        // Call the drag callback continously. Don't do anything too intensive
        // in this callback.
        $79540f7d89e4ab44$var$getOption(options, 'onDrag', $79540f7d89e4ab44$var$NOOP)(getSizes());
    }
    // Cache some important sizes when drag starts, so we don't have to do that
    // continously:
    //
    // `size`: The total size of the pair. First + second + first gutter + second gutter.
    // `start`: The leading side of the first element.
    //
    // ------------------------------------------------
    // |      aGutterSize -> |||                      |
    // |                     |||                      |
    // |                     |||                      |
    // |                     ||| <- bGutterSize       |
    // ------------------------------------------------
    // | <- start                             size -> |
    function calculateSizes() {
        // Figure out the parent size minus padding.
        var a = elements[this.a].element;
        var b = elements[this.b].element;
        var aBounds = a[$79540f7d89e4ab44$var$getBoundingClientRect]();
        var bBounds = b[$79540f7d89e4ab44$var$getBoundingClientRect]();
        this.size = aBounds[dimension] + bBounds[dimension] + this[$79540f7d89e4ab44$var$aGutterSize] + this[$79540f7d89e4ab44$var$bGutterSize];
        this.start = aBounds[position];
        this.end = aBounds[positionEnd];
    }
    function innerSize(element) {
        // Return nothing if getComputedStyle is not supported (< IE9)
        // Or if parent element has no layout yet
        if (!getComputedStyle) return null;
        var computedStyle = getComputedStyle(element);
        if (!computedStyle) return null;
        var size = element[clientSize];
        if (size === 0) return null;
        if (direction === $79540f7d89e4ab44$var$HORIZONTAL) size -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
        else size -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
        return size;
    }
    // When specifying percentage sizes that are less than the computed
    // size of the element minus the gutter, the lesser percentages must be increased
    // (and decreased from the other elements) to make space for the pixels
    // subtracted by the gutters.
    function trimToMin(sizesToTrim) {
        // Try to get inner size of parent element.
        // If it's no supported, return original sizes.
        var parentSize = innerSize(parent);
        if (parentSize === null) return sizesToTrim;
        if (minSizes.reduce(function(a, b) {
            return a + b;
        }, 0) > parentSize) return sizesToTrim;
        // Keep track of the excess pixels, the amount of pixels over the desired percentage
        // Also keep track of the elements with pixels to spare, to decrease after if needed
        var excessPixels = 0;
        var toSpare = [];
        var pixelSizes = sizesToTrim.map(function(size, i) {
            // Convert requested percentages to pixel sizes
            var pixelSize = parentSize * size / 100;
            var elementGutterSize = $79540f7d89e4ab44$var$getGutterSize(gutterSize, i === 0, i === sizesToTrim.length - 1, gutterAlign);
            var elementMinSize = minSizes[i] + elementGutterSize;
            // If element is too smal, increase excess pixels by the difference
            // and mark that it has no pixels to spare
            if (pixelSize < elementMinSize) {
                excessPixels += elementMinSize - pixelSize;
                toSpare.push(0);
                return elementMinSize;
            }
            // Otherwise, mark the pixels it has to spare and return it's original size
            toSpare.push(pixelSize - elementMinSize);
            return pixelSize;
        });
        // If nothing was adjusted, return the original sizes
        if (excessPixels === 0) return sizesToTrim;
        return pixelSizes.map(function(pixelSize, i) {
            var newPixelSize = pixelSize;
            // While there's still pixels to take, and there's enough pixels to spare,
            // take as many as possible up to the total excess pixels
            if (excessPixels > 0 && toSpare[i] - excessPixels > 0) {
                var takenPixels = Math.min(excessPixels, toSpare[i] - excessPixels);
                // Subtract the amount taken for the next iteration
                excessPixels -= takenPixels;
                newPixelSize = pixelSize - takenPixels;
            }
            // Return the pixel size adjusted as a percentage
            return newPixelSize / parentSize * 100;
        });
    }
    // stopDragging is very similar to startDragging in reverse.
    function stopDragging() {
        var self = this;
        var a = elements[self.a].element;
        var b = elements[self.b].element;
        if (self.dragging) $79540f7d89e4ab44$var$getOption(options, 'onDragEnd', $79540f7d89e4ab44$var$NOOP)(getSizes());
        self.dragging = false;
        // Remove the stored event listeners. This is why we store them.
        $79540f7d89e4ab44$var$global[$79540f7d89e4ab44$var$removeEventListener]('mouseup', self.stop);
        $79540f7d89e4ab44$var$global[$79540f7d89e4ab44$var$removeEventListener]('touchend', self.stop);
        $79540f7d89e4ab44$var$global[$79540f7d89e4ab44$var$removeEventListener]('touchcancel', self.stop);
        $79540f7d89e4ab44$var$global[$79540f7d89e4ab44$var$removeEventListener]('mousemove', self.move);
        $79540f7d89e4ab44$var$global[$79540f7d89e4ab44$var$removeEventListener]('touchmove', self.move);
        // Clear bound function references
        self.stop = null;
        self.move = null;
        a[$79540f7d89e4ab44$var$removeEventListener]('selectstart', $79540f7d89e4ab44$var$NOOP);
        a[$79540f7d89e4ab44$var$removeEventListener]('dragstart', $79540f7d89e4ab44$var$NOOP);
        b[$79540f7d89e4ab44$var$removeEventListener]('selectstart', $79540f7d89e4ab44$var$NOOP);
        b[$79540f7d89e4ab44$var$removeEventListener]('dragstart', $79540f7d89e4ab44$var$NOOP);
        a.style.userSelect = '';
        a.style.webkitUserSelect = '';
        a.style.MozUserSelect = '';
        a.style.pointerEvents = '';
        b.style.userSelect = '';
        b.style.webkitUserSelect = '';
        b.style.MozUserSelect = '';
        b.style.pointerEvents = '';
        self.gutter.style.cursor = '';
        self.parent.style.cursor = '';
        $79540f7d89e4ab44$var$document.body.style.cursor = '';
    }
    // startDragging calls `calculateSizes` to store the inital size in the pair object.
    // It also adds event listeners for mouse/touch events,
    // and prevents selection while dragging so avoid the selecting text.
    function startDragging(e) {
        // Right-clicking can't start dragging.
        if ('button' in e && e.button !== 0) return;
        // Alias frequently used variables to save space. 200 bytes.
        var self = this;
        var a = elements[self.a].element;
        var b = elements[self.b].element;
        // Call the onDragStart callback.
        if (!self.dragging) $79540f7d89e4ab44$var$getOption(options, 'onDragStart', $79540f7d89e4ab44$var$NOOP)(getSizes());
        // Don't actually drag the element. We emulate that in the drag function.
        e.preventDefault();
        // Set the dragging property of the pair object.
        self.dragging = true;
        // Create two event listeners bound to the same pair object and store
        // them in the pair object.
        self.move = drag.bind(self);
        self.stop = stopDragging.bind(self);
        // All the binding. `window` gets the stop events in case we drag out of the elements.
        $79540f7d89e4ab44$var$global[$79540f7d89e4ab44$var$addEventListener]('mouseup', self.stop);
        $79540f7d89e4ab44$var$global[$79540f7d89e4ab44$var$addEventListener]('touchend', self.stop);
        $79540f7d89e4ab44$var$global[$79540f7d89e4ab44$var$addEventListener]('touchcancel', self.stop);
        $79540f7d89e4ab44$var$global[$79540f7d89e4ab44$var$addEventListener]('mousemove', self.move);
        $79540f7d89e4ab44$var$global[$79540f7d89e4ab44$var$addEventListener]('touchmove', self.move);
        // Disable selection. Disable!
        a[$79540f7d89e4ab44$var$addEventListener]('selectstart', $79540f7d89e4ab44$var$NOOP);
        a[$79540f7d89e4ab44$var$addEventListener]('dragstart', $79540f7d89e4ab44$var$NOOP);
        b[$79540f7d89e4ab44$var$addEventListener]('selectstart', $79540f7d89e4ab44$var$NOOP);
        b[$79540f7d89e4ab44$var$addEventListener]('dragstart', $79540f7d89e4ab44$var$NOOP);
        a.style.userSelect = 'none';
        a.style.webkitUserSelect = 'none';
        a.style.MozUserSelect = 'none';
        a.style.pointerEvents = 'none';
        b.style.userSelect = 'none';
        b.style.webkitUserSelect = 'none';
        b.style.MozUserSelect = 'none';
        b.style.pointerEvents = 'none';
        // Set the cursor at multiple levels
        self.gutter.style.cursor = cursor;
        self.parent.style.cursor = cursor;
        $79540f7d89e4ab44$var$document.body.style.cursor = cursor;
        // Cache the initial sizes of the pair.
        calculateSizes.call(self);
        // Determine the position of the mouse compared to the gutter
        self.dragOffset = getMousePosition(e) - self.end;
    }
    // adjust sizes to ensure percentage is within min size and gutter.
    sizes = trimToMin(sizes);
    // 5. Create pair and element objects. Each pair has an index reference to
    // elements `a` and `b` of the pair (first and second elements).
    // Loop through the elements while pairing them off. Every pair gets a
    // `pair` object and a gutter.
    //
    // Basic logic:
    //
    // - Starting with the second element `i > 0`, create `pair` objects with
    //   `a = i - 1` and `b = i`
    // - Set gutter sizes based on the _pair_ being first/last. The first and last
    //   pair have gutterSize / 2, since they only have one half gutter, and not two.
    // - Create gutter elements and add event listeners.
    // - Set the size of the elements, minus the gutter sizes.
    //
    // -----------------------------------------------------------------------
    // |     i=0     |         i=1         |        i=2       |      i=3     |
    // |             |                     |                  |              |
    // |           pair 0                pair 1             pair 2           |
    // |             |                     |                  |              |
    // -----------------------------------------------------------------------
    var pairs = [];
    elements = ids.map(function(id, i) {
        // Create the element object.
        var element = {
            element: $79540f7d89e4ab44$var$elementOrSelector(id),
            size: sizes[i],
            minSize: minSizes[i],
            maxSize: maxSizes[i],
            snapOffset: snapOffsets[i],
            i: i
        };
        var pair;
        if (i > 0) {
            // Create the pair object with its metadata.
            pair = {
                a: i - 1,
                b: i,
                dragging: false,
                direction: direction,
                parent: parent
            };
            pair[$79540f7d89e4ab44$var$aGutterSize] = $79540f7d89e4ab44$var$getGutterSize(gutterSize, i - 1 === 0, false, gutterAlign);
            pair[$79540f7d89e4ab44$var$bGutterSize] = $79540f7d89e4ab44$var$getGutterSize(gutterSize, false, i === ids.length - 1, gutterAlign);
            // if the parent has a reverse flex-direction, switch the pair elements.
            if (parentFlexDirection === 'row-reverse' || parentFlexDirection === 'column-reverse') {
                var temp = pair.a;
                pair.a = pair.b;
                pair.b = temp;
            }
        }
        // Determine the size of the current element. IE8 is supported by
        // staticly assigning sizes without draggable gutters. Assigns a string
        // to `size`.
        //
        // Create gutter elements for each pair.
        if (i > 0) {
            var gutterElement = gutter(i, direction, element.element);
            setGutterSize(gutterElement, gutterSize, i);
            // Save bound event listener for removal later
            pair[$79540f7d89e4ab44$var$gutterStartDragging] = startDragging.bind(pair);
            // Attach bound event listener
            gutterElement[$79540f7d89e4ab44$var$addEventListener]('mousedown', pair[$79540f7d89e4ab44$var$gutterStartDragging]);
            gutterElement[$79540f7d89e4ab44$var$addEventListener]('touchstart', pair[$79540f7d89e4ab44$var$gutterStartDragging]);
            parent.insertBefore(gutterElement, element.element);
            pair.gutter = gutterElement;
        }
        setElementSize(element.element, element.size, $79540f7d89e4ab44$var$getGutterSize(gutterSize, i === 0, i === ids.length - 1, gutterAlign), i);
        // After the first iteration, and we have a pair object, append it to the
        // list of pairs.
        if (i > 0) pairs.push(pair);
        return element;
    });
    function adjustToMin(element) {
        var isLast = element.i === pairs.length;
        var pair = isLast ? pairs[element.i - 1] : pairs[element.i];
        calculateSizes.call(pair);
        var size = isLast ? pair.size - element.minSize - pair[$79540f7d89e4ab44$var$bGutterSize] : element.minSize + pair[$79540f7d89e4ab44$var$aGutterSize];
        adjust.call(pair, size);
    }
    elements.forEach(function(element) {
        var computedSize = element.element[$79540f7d89e4ab44$var$getBoundingClientRect]()[dimension];
        if (computedSize < element.minSize) {
            if (expandToMin) adjustToMin(element);
            else // eslint-disable-next-line no-param-reassign
            element.minSize = computedSize;
        }
    });
    function setSizes(newSizes) {
        var trimmed = trimToMin(newSizes);
        trimmed.forEach(function(newSize, i) {
            if (i > 0) {
                var pair = pairs[i - 1];
                var a = elements[pair.a];
                var b = elements[pair.b];
                a.size = trimmed[i - 1];
                b.size = newSize;
                setElementSize(a.element, a.size, pair[$79540f7d89e4ab44$var$aGutterSize], a.i);
                setElementSize(b.element, b.size, pair[$79540f7d89e4ab44$var$bGutterSize], b.i);
            }
        });
    }
    function destroy(preserveStyles, preserveGutter) {
        pairs.forEach(function(pair) {
            if (preserveGutter !== true) pair.parent.removeChild(pair.gutter);
            else {
                pair.gutter[$79540f7d89e4ab44$var$removeEventListener]('mousedown', pair[$79540f7d89e4ab44$var$gutterStartDragging]);
                pair.gutter[$79540f7d89e4ab44$var$removeEventListener]('touchstart', pair[$79540f7d89e4ab44$var$gutterStartDragging]);
            }
            if (preserveStyles !== true) {
                var style = elementStyle(dimension, pair.a.size, pair[$79540f7d89e4ab44$var$aGutterSize]);
                Object.keys(style).forEach(function(prop) {
                    elements[pair.a].element.style[prop] = '';
                    elements[pair.b].element.style[prop] = '';
                });
            }
        });
    }
    return {
        setSizes: setSizes,
        getSizes: getSizes,
        collapse: function collapse(i) {
            adjustToMin(elements[i]);
        },
        destroy: destroy,
        parent: parent,
        pairs: pairs
    };
};
var $79540f7d89e4ab44$export$2e2bcd8739ae039 = $79540f7d89e4ab44$var$Split;

});

parcelRegister("7ak74", function(module, exports) {

$parcel$export(module.exports, "lint", () => $5379119ff8410e3c$export$8fa307edadeef9d7);
$parcel$export(module.exports, "format", () => $5379119ff8410e3c$export$d9468344d3651243);
$parcel$export(module.exports, "default", () => $5379119ff8410e3c$export$2e2bcd8739ae039);
let $5379119ff8410e3c$var$wasm;
const $5379119ff8410e3c$var$cachedTextDecoder = typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8', {
    ignoreBOM: true,
    fatal: true
}) : {
    decode: ()=>{
        throw Error('TextDecoder not available');
    }
};
if (typeof TextDecoder !== 'undefined') $5379119ff8410e3c$var$cachedTextDecoder.decode();
let $5379119ff8410e3c$var$cachedUint8ArrayMemory0 = null;
function $5379119ff8410e3c$var$getUint8ArrayMemory0() {
    if ($5379119ff8410e3c$var$cachedUint8ArrayMemory0 === null || $5379119ff8410e3c$var$cachedUint8ArrayMemory0.byteLength === 0) $5379119ff8410e3c$var$cachedUint8ArrayMemory0 = new Uint8Array($5379119ff8410e3c$var$wasm.memory.buffer);
    return $5379119ff8410e3c$var$cachedUint8ArrayMemory0;
}
function $5379119ff8410e3c$var$getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $5379119ff8410e3c$var$cachedTextDecoder.decode($5379119ff8410e3c$var$getUint8ArrayMemory0().subarray(ptr, ptr + len));
}
function $5379119ff8410e3c$var$addToExternrefTable0(obj) {
    const idx = $5379119ff8410e3c$var$wasm.__externref_table_alloc();
    $5379119ff8410e3c$var$wasm.__wbindgen_export_2.set(idx, obj);
    return idx;
}
function $5379119ff8410e3c$var$handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = $5379119ff8410e3c$var$addToExternrefTable0(e);
        $5379119ff8410e3c$var$wasm.__wbindgen_exn_store(idx);
    }
}
function $5379119ff8410e3c$var$isLikeNone(x) {
    return x === undefined || x === null;
}
let $5379119ff8410e3c$var$WASM_VECTOR_LEN = 0;
const $5379119ff8410e3c$var$cachedTextEncoder = typeof TextEncoder !== 'undefined' ? new TextEncoder('utf-8') : {
    encode: ()=>{
        throw Error('TextEncoder not available');
    }
};
const $5379119ff8410e3c$var$encodeString = typeof $5379119ff8410e3c$var$cachedTextEncoder.encodeInto === 'function' ? function(arg, view) {
    return $5379119ff8410e3c$var$cachedTextEncoder.encodeInto(arg, view);
} : function(arg, view) {
    const buf = $5379119ff8410e3c$var$cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
};
function $5379119ff8410e3c$var$passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = $5379119ff8410e3c$var$cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        $5379119ff8410e3c$var$getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        $5379119ff8410e3c$var$WASM_VECTOR_LEN = buf.length;
        return ptr;
    }
    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;
    const mem = $5379119ff8410e3c$var$getUint8ArrayMemory0();
    let offset = 0;
    for(; offset < len; offset++){
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) arg = arg.slice(offset);
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = $5379119ff8410e3c$var$getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = $5379119ff8410e3c$var$encodeString(arg, view);
        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }
    $5379119ff8410e3c$var$WASM_VECTOR_LEN = offset;
    return ptr;
}
let $5379119ff8410e3c$var$cachedDataViewMemory0 = null;
function $5379119ff8410e3c$var$getDataViewMemory0() {
    if ($5379119ff8410e3c$var$cachedDataViewMemory0 === null || $5379119ff8410e3c$var$cachedDataViewMemory0.buffer.detached === true || $5379119ff8410e3c$var$cachedDataViewMemory0.buffer.detached === undefined && $5379119ff8410e3c$var$cachedDataViewMemory0.buffer !== $5379119ff8410e3c$var$wasm.memory.buffer) $5379119ff8410e3c$var$cachedDataViewMemory0 = new DataView($5379119ff8410e3c$var$wasm.memory.buffer);
    return $5379119ff8410e3c$var$cachedDataViewMemory0;
}
const $5379119ff8410e3c$var$CLOSURE_DTORS = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((state)=>{
    $5379119ff8410e3c$var$wasm.__wbindgen_export_5.get(state.dtor)(state.a, state.b);
});
function $5379119ff8410e3c$var$makeClosure(arg0, arg1, dtor, f) {
    const state = {
        a: arg0,
        b: arg1,
        cnt: 1,
        dtor: dtor
    };
    const real = (...args)=>{
        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        try {
            return f(state.a, state.b, ...args);
        } finally{
            if (--state.cnt === 0) {
                $5379119ff8410e3c$var$wasm.__wbindgen_export_5.get(state.dtor)(state.a, state.b);
                state.a = 0;
                $5379119ff8410e3c$var$CLOSURE_DTORS.unregister(state);
            }
        }
    };
    real.original = state;
    $5379119ff8410e3c$var$CLOSURE_DTORS.register(real, state, state);
    return real;
}
function $5379119ff8410e3c$var$makeMutClosure(arg0, arg1, dtor, f) {
    const state = {
        a: arg0,
        b: arg1,
        cnt: 1,
        dtor: dtor
    };
    const real = (...args)=>{
        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        const a = state.a;
        state.a = 0;
        try {
            return f(a, state.b, ...args);
        } finally{
            if (--state.cnt === 0) {
                $5379119ff8410e3c$var$wasm.__wbindgen_export_5.get(state.dtor)(a, state.b);
                $5379119ff8410e3c$var$CLOSURE_DTORS.unregister(state);
            } else state.a = a;
        }
    };
    real.original = state;
    $5379119ff8410e3c$var$CLOSURE_DTORS.register(real, state, state);
    return real;
}
function $5379119ff8410e3c$export$8fa307edadeef9d7(grammar) {
    const ret = $5379119ff8410e3c$var$wasm.lint(grammar);
    return ret;
}
function $5379119ff8410e3c$export$b3571188c770cc5a() {
    $5379119ff8410e3c$var$wasm.start();
}
function $5379119ff8410e3c$export$d9468344d3651243(grammar) {
    const ret = $5379119ff8410e3c$var$wasm.format(grammar);
    return ret;
}
function $5379119ff8410e3c$export$98e6a39c04603d36(rule, input) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = $5379119ff8410e3c$var$passStringToWasm0(rule, $5379119ff8410e3c$var$wasm.__wbindgen_malloc, $5379119ff8410e3c$var$wasm.__wbindgen_realloc);
        const len0 = $5379119ff8410e3c$var$WASM_VECTOR_LEN;
        const ptr1 = $5379119ff8410e3c$var$passStringToWasm0(input, $5379119ff8410e3c$var$wasm.__wbindgen_malloc, $5379119ff8410e3c$var$wasm.__wbindgen_realloc);
        const len1 = $5379119ff8410e3c$var$WASM_VECTOR_LEN;
        const ret = $5379119ff8410e3c$var$wasm.parse(ptr0, len0, ptr1, len1);
        deferred3_0 = ret[0];
        deferred3_1 = ret[1];
        return $5379119ff8410e3c$var$getStringFromWasm0(ret[0], ret[1]);
    } finally{
        $5379119ff8410e3c$var$wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}
function $5379119ff8410e3c$var$__wbg_adapter_22(arg0, arg1, arg2) {
    $5379119ff8410e3c$var$wasm.closure9_externref_shim(arg0, arg1, arg2);
}
function $5379119ff8410e3c$var$__wbg_adapter_27(arg0, arg1) {
    $5379119ff8410e3c$var$wasm._dyn_core_608f92abc48d28da___ops__function__FnMut_____Output______as_wasm_bindgen_3c92293a84a0f1b2___closure__WasmClosure___describe__invoke______(arg0, arg1);
}
async function $5379119ff8410e3c$var$__wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') try {
            return await WebAssembly.instantiateStreaming(module, imports);
        } catch (e) {
            if (module.headers.get('Content-Type') != 'application/wasm') console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);
            else throw e;
        }
        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);
        if (instance instanceof WebAssembly.Instance) return {
            instance: instance,
            module: module
        };
        else return instance;
    }
}
function $5379119ff8410e3c$var$__wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbg_addEventListener_90e553fdce254421 = function() {
        return $5379119ff8410e3c$var$handleError(function(arg0, arg1, arg2, arg3) {
            arg0.addEventListener($5379119ff8410e3c$var$getStringFromWasm0(arg1, arg2), arg3);
        }, arguments);
    };
    imports.wbg.__wbg_appendChild_8204974b7328bf98 = function() {
        return $5379119ff8410e3c$var$handleError(function(arg0, arg1) {
            const ret = arg0.appendChild(arg1);
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_call_672a4d21634d4a24 = function() {
        return $5379119ff8410e3c$var$handleError(function(arg0, arg1) {
            const ret = arg0.call(arg1);
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_createElement_8c9931a732ee2fea = function() {
        return $5379119ff8410e3c$var$handleError(function(arg0, arg1, arg2) {
            const ret = arg0.createElement($5379119ff8410e3c$var$getStringFromWasm0(arg1, arg2));
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_createTextNode_42af1a9f21bb3360 = function(arg0, arg1, arg2) {
        const ret = arg0.createTextNode($5379119ff8410e3c$var$getStringFromWasm0(arg1, arg2));
        return ret;
    };
    imports.wbg.__wbg_dispatchEvent_9e259d7c1d603dfb = function() {
        return $5379119ff8410e3c$var$handleError(function(arg0, arg1) {
            const ret = arg0.dispatchEvent(arg1);
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_document_d249400bd7bd996d = function(arg0) {
        const ret = arg0.document;
        return $5379119ff8410e3c$var$isLikeNone(ret) ? 0 : $5379119ff8410e3c$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_firstChild_b0603462b5172539 = function(arg0) {
        const ret = arg0.firstChild;
        return $5379119ff8410e3c$var$isLikeNone(ret) ? 0 : $5379119ff8410e3c$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_getItem_17f98dee3b43fa7e = function() {
        return $5379119ff8410e3c$var$handleError(function(arg0, arg1, arg2, arg3) {
            const ret = arg1.getItem($5379119ff8410e3c$var$getStringFromWasm0(arg2, arg3));
            var ptr1 = $5379119ff8410e3c$var$isLikeNone(ret) ? 0 : $5379119ff8410e3c$var$passStringToWasm0(ret, $5379119ff8410e3c$var$wasm.__wbindgen_malloc, $5379119ff8410e3c$var$wasm.__wbindgen_realloc);
            var len1 = $5379119ff8410e3c$var$WASM_VECTOR_LEN;
            $5379119ff8410e3c$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $5379119ff8410e3c$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        }, arguments);
    };
    imports.wbg.__wbg_instanceof_HtmlOptionElement_b1b0aa85b994ebba = function(arg0) {
        let result;
        try {
            result = arg0 instanceof HTMLOptionElement;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_instanceof_HtmlSelectElement_2ae72edd07bf938c = function(arg0) {
        let result;
        try {
            result = arg0 instanceof HTMLSelectElement;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_instanceof_Node_fbc6b87f5ed2e230 = function(arg0) {
        let result;
        try {
            result = arg0 instanceof Node;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_instanceof_Window_def73ea0955fc569 = function(arg0) {
        let result;
        try {
            result = arg0 instanceof Window;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_item_cfe204c1386c8374 = function(arg0, arg1) {
        const ret = arg0.item(arg1 >>> 0);
        return $5379119ff8410e3c$var$isLikeNone(ret) ? 0 : $5379119ff8410e3c$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_localStorage_1406c99c39728187 = function() {
        return $5379119ff8410e3c$var$handleError(function(arg0) {
            const ret = arg0.localStorage;
            return $5379119ff8410e3c$var$isLikeNone(ret) ? 0 : $5379119ff8410e3c$var$addToExternrefTable0(ret);
        }, arguments);
    };
    imports.wbg.__wbg_new_1b8f676ab7549097 = function() {
        return $5379119ff8410e3c$var$handleError(function(arg0, arg1) {
            const ret = new CustomEvent($5379119ff8410e3c$var$getStringFromWasm0(arg0, arg1));
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_new_405e22f390576ce2 = function() {
        const ret = new Object();
        return ret;
    };
    imports.wbg.__wbg_new_5e0be73521bc8c17 = function() {
        const ret = new Map();
        return ret;
    };
    imports.wbg.__wbg_new_78feb108b6472713 = function() {
        const ret = new Array();
        return ret;
    };
    imports.wbg.__wbg_newnoargs_105ed471475aaf50 = function(arg0, arg1) {
        const ret = new Function($5379119ff8410e3c$var$getStringFromWasm0(arg0, arg1));
        return ret;
    };
    imports.wbg.__wbg_querySelector_c69f8b573958906b = function() {
        return $5379119ff8410e3c$var$handleError(function(arg0, arg1, arg2) {
            const ret = arg0.querySelector($5379119ff8410e3c$var$getStringFromWasm0(arg1, arg2));
            return $5379119ff8410e3c$var$isLikeNone(ret) ? 0 : $5379119ff8410e3c$var$addToExternrefTable0(ret);
        }, arguments);
    };
    imports.wbg.__wbg_removeChild_841bf1dc802c0a2c = function() {
        return $5379119ff8410e3c$var$handleError(function(arg0, arg1) {
            const ret = arg0.removeChild(arg1);
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_selectedOptions_aa3e13a849515d8a = function(arg0) {
        const ret = arg0.selectedOptions;
        return ret;
    };
    imports.wbg.__wbg_setTimeout_f2fe5af8e3debeb3 = function() {
        return $5379119ff8410e3c$var$handleError(function(arg0, arg1, arg2) {
            const ret = arg0.setTimeout(arg1, arg2);
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_set_37837023f3d740e8 = function(arg0, arg1, arg2) {
        arg0[arg1 >>> 0] = arg2;
    };
    imports.wbg.__wbg_set_3f1d0b984ed272ed = function(arg0, arg1, arg2) {
        arg0[arg1] = arg2;
    };
    imports.wbg.__wbg_set_8fc6bf8a5b1071d1 = function(arg0, arg1, arg2) {
        const ret = arg0.set(arg1, arg2);
        return ret;
    };
    imports.wbg.__wbg_setdisabled_2584718da5d1b99b = function(arg0, arg1) {
        arg0.disabled = arg1 !== 0;
    };
    imports.wbg.__wbg_setselected_107e006e3458410d = function(arg0, arg1) {
        arg0.selected = arg1 !== 0;
    };
    imports.wbg.__wbg_static_accessor_GLOBAL_88a902d13a557d07 = function() {
        const ret = typeof $parcel$global === 'undefined' ? null : $parcel$global;
        return $5379119ff8410e3c$var$isLikeNone(ret) ? 0 : $5379119ff8410e3c$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_GLOBAL_THIS_56578be7e9f832b0 = function() {
        const ret = typeof globalThis === 'undefined' ? null : globalThis;
        return $5379119ff8410e3c$var$isLikeNone(ret) ? 0 : $5379119ff8410e3c$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_SELF_37c5d418e4bf5819 = function() {
        const ret = typeof self === 'undefined' ? null : self;
        return $5379119ff8410e3c$var$isLikeNone(ret) ? 0 : $5379119ff8410e3c$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_WINDOW_5de37043a91a9c40 = function() {
        const ret = typeof window === 'undefined' ? null : window;
        return $5379119ff8410e3c$var$isLikeNone(ret) ? 0 : $5379119ff8410e3c$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_textContent_215d0f87d539368a = function(arg0, arg1) {
        const ret = arg1.textContent;
        var ptr1 = $5379119ff8410e3c$var$isLikeNone(ret) ? 0 : $5379119ff8410e3c$var$passStringToWasm0(ret, $5379119ff8410e3c$var$wasm.__wbindgen_malloc, $5379119ff8410e3c$var$wasm.__wbindgen_realloc);
        var len1 = $5379119ff8410e3c$var$WASM_VECTOR_LEN;
        $5379119ff8410e3c$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
        $5379119ff8410e3c$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
    };
    imports.wbg.__wbindgen_cb_drop = function(arg0) {
        const obj = arg0.original;
        if (obj.cnt-- == 1) {
            obj.a = 0;
            return true;
        }
        const ret = false;
        return ret;
    };
    imports.wbg.__wbindgen_closure_wrapper86 = function(arg0, arg1, arg2) {
        const ret = $5379119ff8410e3c$var$makeClosure(arg0, arg1, 10, $5379119ff8410e3c$var$__wbg_adapter_22);
        return ret;
    };
    imports.wbg.__wbindgen_closure_wrapper87 = function(arg0, arg1, arg2) {
        const ret = $5379119ff8410e3c$var$makeClosure(arg0, arg1, 10, $5379119ff8410e3c$var$__wbg_adapter_22);
        return ret;
    };
    imports.wbg.__wbindgen_closure_wrapper92 = function(arg0, arg1, arg2) {
        const ret = $5379119ff8410e3c$var$makeMutClosure(arg0, arg1, 10, $5379119ff8410e3c$var$__wbg_adapter_27);
        return ret;
    };
    imports.wbg.__wbindgen_error_new = function(arg0, arg1) {
        const ret = new Error($5379119ff8410e3c$var$getStringFromWasm0(arg0, arg1));
        return ret;
    };
    imports.wbg.__wbindgen_init_externref_table = function() {
        const table = $5379119ff8410e3c$var$wasm.__wbindgen_export_2;
        const offset = table.grow(4);
        table.set(0, undefined);
        table.set(offset + 0, undefined);
        table.set(offset + 1, null);
        table.set(offset + 2, true);
        table.set(offset + 3, false);
    };
    imports.wbg.__wbindgen_is_string = function(arg0) {
        const ret = typeof arg0 === 'string';
        return ret;
    };
    imports.wbg.__wbindgen_is_undefined = function(arg0) {
        const ret = arg0 === undefined;
        return ret;
    };
    imports.wbg.__wbindgen_string_get = function(arg0, arg1) {
        const obj = arg1;
        const ret = typeof obj === 'string' ? obj : undefined;
        var ptr1 = $5379119ff8410e3c$var$isLikeNone(ret) ? 0 : $5379119ff8410e3c$var$passStringToWasm0(ret, $5379119ff8410e3c$var$wasm.__wbindgen_malloc, $5379119ff8410e3c$var$wasm.__wbindgen_realloc);
        var len1 = $5379119ff8410e3c$var$WASM_VECTOR_LEN;
        $5379119ff8410e3c$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
        $5379119ff8410e3c$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
    };
    imports.wbg.__wbindgen_string_new = function(arg0, arg1) {
        const ret = $5379119ff8410e3c$var$getStringFromWasm0(arg0, arg1);
        return ret;
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error($5379119ff8410e3c$var$getStringFromWasm0(arg0, arg1));
    };
    return imports;
}
function $5379119ff8410e3c$var$__wbg_init_memory(imports, memory) {}
function $5379119ff8410e3c$var$__wbg_finalize_init(instance, module) {
    $5379119ff8410e3c$var$wasm = instance.exports;
    $5379119ff8410e3c$var$__wbg_init.__wbindgen_wasm_module = module;
    $5379119ff8410e3c$var$cachedDataViewMemory0 = null;
    $5379119ff8410e3c$var$cachedUint8ArrayMemory0 = null;
    $5379119ff8410e3c$var$wasm.__wbindgen_start();
    return $5379119ff8410e3c$var$wasm;
}
function $5379119ff8410e3c$export$2ec80ee76a9348bf(module) {
    if ($5379119ff8410e3c$var$wasm !== undefined) return $5379119ff8410e3c$var$wasm;
    if (typeof module !== 'undefined') {
        if (Object.getPrototypeOf(module) === Object.prototype) ({ module: module } = module);
        else console.warn('using deprecated parameters for `initSync()`; pass a single object instead');
    }
    const imports = $5379119ff8410e3c$var$__wbg_get_imports();
    $5379119ff8410e3c$var$__wbg_init_memory(imports);
    if (!(module instanceof WebAssembly.Module)) module = new WebAssembly.Module(module);
    const instance = new WebAssembly.Instance(module, imports);
    return $5379119ff8410e3c$var$__wbg_finalize_init(instance, module);
}

async function $5379119ff8410e3c$var$__wbg_init(module_or_path) {
    if ($5379119ff8410e3c$var$wasm !== undefined) return $5379119ff8410e3c$var$wasm;
    if (typeof module_or_path !== 'undefined') {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) ({ module_or_path: module_or_path } = module_or_path);
        else console.warn('using deprecated parameters for the initialization function; pass a single object instead');
    }
    if (typeof module_or_path === 'undefined') module_or_path = new URL((parcelRequire("c5DhZ")));
    const imports = $5379119ff8410e3c$var$__wbg_get_imports();
    if (typeof module_or_path === 'string' || typeof Request === 'function' && module_or_path instanceof Request || typeof URL === 'function' && module_or_path instanceof URL) module_or_path = fetch(module_or_path);
    $5379119ff8410e3c$var$__wbg_init_memory(imports);
    const { instance: instance, module: module } = await $5379119ff8410e3c$var$__wbg_load(await module_or_path, imports);
    return $5379119ff8410e3c$var$__wbg_finalize_init(instance, module);
}
var $5379119ff8410e3c$export$2e2bcd8739ae039 = $5379119ff8410e3c$var$__wbg_init;

});
parcelRegister("c5DhZ", function(module, exports) {
module.exports = import.meta.resolve("cesFG");

});


parcelRegister("jInfY", function(module, exports) {

$parcel$export(module.exports, "initShareButton", () => $ce14cbb96c5244c1$export$a3e9bef18d0e9ac6);

var $8sZjO = parcelRequire("8sZjO");
let $ce14cbb96c5244c1$var$copyButton;
let $ce14cbb96c5244c1$var$copyButtonOriginalText;
let $ce14cbb96c5244c1$var$shareLinkWarning;
function $ce14cbb96c5244c1$export$a3e9bef18d0e9ac6({ myCodeMirror: myCodeMirror }) {
    $ce14cbb96c5244c1$var$shareLinkWarning = document.querySelector("p#shareLinkWarning");
    $ce14cbb96c5244c1$var$tryLoadFromShareLink(myCodeMirror);
    $ce14cbb96c5244c1$var$copyButton = document.querySelector("button#shareLinkBtn");
    $ce14cbb96c5244c1$var$copyButtonOriginalText = $ce14cbb96c5244c1$var$copyButton.innerText;
    $ce14cbb96c5244c1$var$copyButton.onclick = ()=>$ce14cbb96c5244c1$var$copyShareLink(myCodeMirror);
}
let $ce14cbb96c5244c1$var$copyButtonTimerHandle = undefined;
function $ce14cbb96c5244c1$var$copyShareLink(codeMirror) {
    clearTimeout($ce14cbb96c5244c1$var$copyButtonTimerHandle);
    const url = $ce14cbb96c5244c1$var$shareURL(codeMirror);
    if (url.length > 2000) $ce14cbb96c5244c1$var$setShareLinkLengthWarning();
    else $ce14cbb96c5244c1$var$clearShareLinkWarning();
    navigator.clipboard.writeText(url);
    $ce14cbb96c5244c1$var$copyButton.classList.add("copied");
    $ce14cbb96c5244c1$var$copyButton.innerText = "Copied";
    $ce14cbb96c5244c1$var$copyButtonTimerHandle = window.setTimeout(()=>{
        $ce14cbb96c5244c1$var$copyButton.classList.remove("copied");
        $ce14cbb96c5244c1$var$copyButton.innerText = $ce14cbb96c5244c1$var$copyButtonOriginalText;
    }, 1400);
}
function $ce14cbb96c5244c1$var$tryLoadFromShareLink(codeMirror) {
    const url = new URL(window.location.href);
    const gdata = url.searchParams.get("g");
    if (gdata) {
        const decoded = $ce14cbb96c5244c1$var$decodeShareData(gdata);
        codeMirror.setValue(decoded["grammar"]);
        const inputEditor = document.querySelector("textarea.editor-input-text");
        inputEditor.value = decoded["input"];
        if (decoded["selectedRule"]) localStorage.setItem("last-selected-rule", decoded["selectedRule"]);
    }
}
function $ce14cbb96c5244c1$var$shareData(codeMirror) {
    return {
        grammar: codeMirror.getValue(),
        input: document.querySelector("textarea.editor-input-text").value,
        selectedRule: localStorage.getItem("last-selected-rule") || ""
    };
}
function $ce14cbb96c5244c1$var$shareURL(codeMirror) {
    const gdata = $ce14cbb96c5244c1$var$encodeShareData($ce14cbb96c5244c1$var$shareData(codeMirror));
    const url = new URL(window.location.href);
    url.searchParams.set("g", gdata);
    url.hash = "editor";
    return url.toString();
}
function $ce14cbb96c5244c1$var$setShareLinkLengthWarning() {
    $ce14cbb96c5244c1$var$shareLinkWarning.innerText = "Share link > 2000 chars; it may not work.";
    $ce14cbb96c5244c1$var$shareLinkWarning.style.display = null;
}
function $ce14cbb96c5244c1$var$clearShareLinkWarning() {
    $ce14cbb96c5244c1$var$shareLinkWarning.innerText = "";
    $ce14cbb96c5244c1$var$shareLinkWarning.style.display = "none";
}
function $ce14cbb96c5244c1$var$encodeShareData(data) {
    return (0, $8sZjO.compressToEncodedURIComponent)(JSON.stringify(data));
}
function $ce14cbb96c5244c1$var$decodeShareData(encoded) {
    return JSON.parse((0, $8sZjO.decompressFromEncodedURIComponent)(encoded));
}

});
parcelRegister("8sZjO", function(module, exports) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(''));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join('');
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join('');
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === 'function' && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;
else if (typeof angular !== 'undefined' && angular != null) angular.module('LZString', []).factory('LZString', function() {
    return LZString;
});

});


parcelRegister("jouGq", function(module, exports) {

var $fzrL4 = parcelRequire("fzrL4");
let $e1e80f43565aad58$var$url = new URL(import.meta.resolve("cj86N"));
module.exports = $fzrL4($e1e80f43565aad58$var$url.toString(), $e1e80f43565aad58$var$url.origin, true);

});
parcelRegister("fzrL4", function(module, exports) {
"use strict";
module.exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};

});




parcelRequire("dMIJ2");

//# sourceMappingURL=static.2322b244.js.map
